import React from 'react'
import ReactMarkdown from 'react-markdown'
import { useTheme } from '../../context/themeContext'
import Button from '../../shared/Button/Button'
import useAllSitePage from '../../hooks/useAllSitePage'
import './Hero.scss'

const Hero = ({ data }) => {
  const { theme } = useTheme()
  const pagesPath = useAllSitePage()
  const { allSitePage: matchPages } = pagesPath
  
  const title = data?.title
  const summary = data?.summary
  const image = data?.image
  const imageDark = data?.imageDark
  const button = data?.dynamicButton

  return (
    <div className={'hero container my-3 my-md-5'} id={'hero-' + data.id}>
      <div className="hero-container row container-md">
        <div className="col-12 col-lg-6">
          <span className='hero-title'>{title}</span>
          <ReactMarkdown 
            renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
            children={summary} className="hero-markdown" />
          {button && 
            <Button
              icon={button?.icon}
              customButton={button?.customButton}
              button={button?.button}
              classContainer={'button'}
              matchPages={matchPages?.nodes}
            />
          }
        </div>
        <div className={`imagen col-12 col-lg-6`}>
          {image?.url && 
            <img
              src={theme === 'dark' && imageDark ? imageDark?.url : image?.url}
              alt={title}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default Hero